export default {
    otp:'Tek Kkullanımlık şifre',
    OTP_NOT_MATCHED: "Tek kullanımlık şifreniz eşleşmiyor",
    OTP_EXPIRED:"'nin süresi doldu",
    OTP_NOT_GENERATED:"Bu kullanıcı için tek kullanımlık şifre oluşturulmadı, önce tek kullanımlık şifrenizi oluşturun",
    LIMIT_EXCEED:"Birden fazla denemeden dolayı şu anda tek kullanımlık şifre'ye giremiyorsunuz, bir süre sonra tekrar deneyin",
    ocbe:"tek kullanımlık şifre alanı boş olmamalı",
    nv:"Geçerli Değil",
    "mobile should not be empty":"Telefon numarası alanı boş olmamalı",
}